import React, { useEffect } from "react";
import userManager from "../../../utils/oidcUserManager";

export function SSOPage() {
    useEffect(() => {
        userManager.signinRedirect();
    }, []);

    return (null);
}
